
import { Mixins, Component, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { tSearch } from '@/components/Search/index';
import tableMixin from './tableMixin';

@Component({
  components: {
    Pagination,
    tSearch,
  },
})
export default class Setting extends Mixins(tableMixin) {
  private searchString: string = '';

  handleAdvancedSearch(search: string) {
    this.searchString = search;
    this.getData(search);
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    if (this.searchString !== '') {
      this.getData(this.searchString);
    } else {
      this.getData();
    }
  }
}
